import { gql } from 'apollo-boost';

export const GET_WECHAT_GROUPS = gql`
  query wechatGroups(
    $pageSize: Int!
    $currentPage: Int!
    $searchTerm: SearchWechatGroupFilter
  ) {
    wechatGroups(
      pageSize: $pageSize
      currentPage: $currentPage
      searchTerm: $searchTerm
    ) {
      _id
      name
      tag
      desc
      owner
      school
      qrCode
      expressDate
      isOnShow
      createdAt
      updatedAt
    }
  }
`;

export const GET_WECHAT_GROUP = gql`
  query wechatGroup($_id: ID!) {
    wechatGroup(_id: $_id) {
      _id
      name
      tag
      desc
      owner
      school
      qrCode
      expressDate
      isOnShow
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_WECHAT_GROUP = gql`
  mutation createWechatGroup($data: CreateWechatGroupInput!) {
    createWechatGroup(data: $data) {
      _id
      name
      tag
      desc
      owner
      school
      qrCode
      expressDate
      isOnShow
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_WECHAT_GROUP = gql`
  mutation updateWechatGroup($_id: ID!, $data: CreateWechatGroupInput!) {
    updateWechatGroup(_id: $_id, data: $data) {
      _id
      name
      tag
      desc
      owner
      school
      qrCode
      expressDate
      isOnShow
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_WECHAT_GROUP = gql`
  mutation deleteWechatGroup($_id: ID!) {
    deleteWechatGroup(_id: $_id) {
      _id
      name
    }
  }
`;